import { get, httpDelete, post, put } from 'api/client';
import config from 'config';
import { getExtendedTimeout } from 'utils/request';
import {
  DemoContentGetResponse,
  DemoContentMutationResponse,
} from 'app/modules/demoContent/types';

const BASE_PATH = '/demo-content';

export const DemoContentApi = {
  getState(): Promise<DemoContentGetResponse> {
    return get(BASE_PATH, {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },
  enable(): Promise<DemoContentMutationResponse> {
    return post(BASE_PATH, undefined, {
      baseURL: config.API_SERVICE_ENDPOINT,
      timeout: getExtendedTimeout(3),
    });
  },
  setEnabled(enabled: boolean): Promise<DemoContentMutationResponse> {
    return put(
      BASE_PATH,
      { enabled },
      {
        baseURL: config.API_SERVICE_ENDPOINT,
        timeout: getExtendedTimeout(3),
      },
    );
  },
  remove(): Promise<DemoContentMutationResponse> {
    return httpDelete(BASE_PATH, {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },
  toggle(): Promise<DemoContentMutationResponse> {
    return post(`${BASE_PATH}/toggle`, undefined, {
      baseURL: config.API_SERVICE_ENDPOINT,
      timeout: getExtendedTimeout(3),
    });
  },
};
